/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockUpdateBase
 */
export interface StockUpdateBase {
    /**
     * PSI企業ID
     * @type {number}
     * @memberof StockUpdateBase
     */
    companyId: number;
    /**
     * PSIセンターID
     * @type {number}
     * @memberof StockUpdateBase
     */
    centerId: number;
    /**
     * 商品コード
     * @type {string}
     * @memberof StockUpdateBase
     */
    itemCode: string;
    /**
     * 
     * @type {Date}
     * @memberof StockUpdateBase
     */
    recDate: Date | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    stockQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    stockDays?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    orderQuantityRecommend?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof StockUpdateBase
     */
    orderRecommendCalcDatetime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    shipQuantityOptimizeBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    shipQuantityStockBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    avgShipQuantityStockBase?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    orderQuantityLpResult?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    minStockForecastBased?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    minStockShortageBased?: number | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    calcSafety?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockUpdateBase
     */
    isOrderQuantityFixed?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    stockQuantityRecMorning?: number | null;
    /**
     * 
     * @type {string}
     * @memberof StockUpdateBase
     */
    predictionMethod?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    numTrain?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof StockUpdateBase
     */
    yearlySeasonality?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof StockUpdateBase
     */
    predictionMapeMedian?: number | null;
}

/**
 * Check if a given object implements the StockUpdateBase interface.
 */
export function instanceOfStockUpdateBase(value: object): value is StockUpdateBase {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('centerId' in value) || value['centerId'] === undefined) return false;
    if (!('itemCode' in value) || value['itemCode'] === undefined) return false;
    if (!('recDate' in value) || value['recDate'] === undefined) return false;
    return true;
}

export function StockUpdateBaseFromJSON(json: any): StockUpdateBase {
    return StockUpdateBaseFromJSONTyped(json, false);
}

export function StockUpdateBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockUpdateBase {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['company_id'],
        'centerId': json['center_id'],
        'itemCode': json['item_code'],
        'recDate': (json['rec_date'] == null ? null : new Date(json['rec_date'])),
        'stockQuantity': json['stock_quantity'] == null ? undefined : json['stock_quantity'],
        'stockDays': json['stock_days'] == null ? undefined : json['stock_days'],
        'orderQuantityRecommend': json['order_quantity_recommend'] == null ? undefined : json['order_quantity_recommend'],
        'orderRecommendCalcDatetime': json['order_recommend_calc_datetime'] == null ? undefined : (new Date(json['order_recommend_calc_datetime'])),
        'shipQuantityOptimizeBase': json['ship_quantity_optimize_base'] == null ? undefined : json['ship_quantity_optimize_base'],
        'shipQuantityStockBase': json['ship_quantity_stock_base'] == null ? undefined : json['ship_quantity_stock_base'],
        'avgShipQuantityStockBase': json['avg_ship_quantity_stock_base'] == null ? undefined : json['avg_ship_quantity_stock_base'],
        'orderQuantityLpResult': json['order_quantity_lp_result'] == null ? undefined : json['order_quantity_lp_result'],
        'minStockForecastBased': json['min_stock_forecast_based'] == null ? undefined : json['min_stock_forecast_based'],
        'minStockShortageBased': json['min_stock_shortage_based'] == null ? undefined : json['min_stock_shortage_based'],
        'calcSafety': json['calc_safety'] == null ? undefined : json['calc_safety'],
        'isOrderQuantityFixed': json['is_order_quantity_fixed'] == null ? undefined : json['is_order_quantity_fixed'],
        'stockQuantityRecMorning': json['stock_quantity_rec_morning'] == null ? undefined : json['stock_quantity_rec_morning'],
        'predictionMethod': json['prediction_method'] == null ? undefined : json['prediction_method'],
        'numTrain': json['num_train'] == null ? undefined : json['num_train'],
        'yearlySeasonality': json['yearly_seasonality'] == null ? undefined : json['yearly_seasonality'],
        'predictionMapeMedian': json['prediction_mape_median'] == null ? undefined : json['prediction_mape_median'],
    };
}

export function StockUpdateBaseToJSON(json: any): StockUpdateBase {
    return StockUpdateBaseToJSONTyped(json, false);
}

export function StockUpdateBaseToJSONTyped(value?: StockUpdateBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['companyId'],
        'center_id': value['centerId'],
        'item_code': value['itemCode'],
        'rec_date': value['recDate'] == null ? value['recDate'] : value['recDate'].toISOString(),
        'stock_quantity': value['stockQuantity'],
        'stock_days': value['stockDays'],
        'order_quantity_recommend': value['orderQuantityRecommend'],
        'order_recommend_calc_datetime': value['orderRecommendCalcDatetime'] == null ? value['orderRecommendCalcDatetime'] : value['orderRecommendCalcDatetime'].toISOString(),
        'ship_quantity_optimize_base': value['shipQuantityOptimizeBase'],
        'ship_quantity_stock_base': value['shipQuantityStockBase'],
        'avg_ship_quantity_stock_base': value['avgShipQuantityStockBase'],
        'order_quantity_lp_result': value['orderQuantityLpResult'],
        'min_stock_forecast_based': value['minStockForecastBased'],
        'min_stock_shortage_based': value['minStockShortageBased'],
        'calc_safety': value['calcSafety'],
        'is_order_quantity_fixed': value['isOrderQuantityFixed'],
        'stock_quantity_rec_morning': value['stockQuantityRecMorning'],
        'prediction_method': value['predictionMethod'],
        'num_train': value['numTrain'],
        'yearly_seasonality': value['yearlySeasonality'],
        'prediction_mape_median': value['predictionMapeMedian'],
    };
}

